module.exports = __webpack_public_path__ + "img/4.393d0168.png";